export default "__VITE_ASSET__CObuYSht__"